import { OnEventDispatcher } from "../../core/on-event-dispatcher";
import { Application } from "../../main";
import { MapSideViewContent } from "./mapsideviewcontent";

const chevron_left:string = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>`;
const chevron_right:string = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>`;

export class MapSideView extends OnEventDispatcher {

    elm: JQuery<HTMLElement>;
    inner: JQuery<HTMLElement>;

    content:MapSideViewContent;
    closeButton: JQuery<HTMLElement>;

    constructor(container:JQuery<HTMLElement>) {
        super();

        this.elm = container.find("> .map-sideview");
        this.inner = this.elm.find(".map-sideview-inner");
        this.closeButton = this.elm.find(".close-button");

        this.closeButton.find(".icon .chevron-left").html(chevron_left);
        this.closeButton.find(".icon .chevron-right").html(chevron_right);

        this.closeButton.on("click", () => {
            this.content.onCloseButtonClick();
        });
    }

    clearInner() {
        this.inner.html("");
        this.inner.attr("class", "map-sideview-inner");
    }

    async open(slug:string = null) {
        if(this.content!=null) await this.content.destroy();
        this.content = new MapSideViewContent(this, slug);
        $("body").addClass("side-view-open");
    }
    close(silent:boolean = false) {
        if(this.content!=null) {
            this.content.destroy();
            this.content = null;
            this.clearInner();
        }
        $("body").removeClass("side-view-open");
    }

}